import { push } from 'connected-react-router';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Url } from 'src/api';
import { IRootState } from 'src/reducers';
import useFetch from 'use-http';

type TractSearchResult = {
    clientNumber: number;
    projectNumber: number;
    fieldNumber: number;
    tractNumber: number;
    tract: {
        id: number;
        legalDescription: string;
        grossAcres: number;
    };
    tractAttributes: unknown;
};

const EasternParcelSearch = () => {
    const appContext = useSelector((state: IRootState) => state.appContext);
    const dispatch = useDispatch();
    const { post, response, error } = useFetch();
    const { register, handleSubmit } = useForm();
    const [searchPerformed, setSearchPerformed] = React.useState(false);
    const [searchResults, setSearchResults] = React.useState<TractSearchResult[]>([]);

    const submitTractSearch = async (payload: { ownerName: string; surfaceTractName: string }) => {
        await post(`${Url.project.base(appContext)}/tracts/search`, payload);

        if (response.ok) {
            setSearchResults(response.data);
        } else {
            console.log(error);
        }
        setSearchPerformed(true);
    };

    const onSubmit = (data: { searchTerm: string }) => {
        const search = {
            ownerName: data.searchTerm,
            surfaceTractName: data.searchTerm,
        };

        submitTractSearch(search);
    };

    const tractCard = (tract: TractSearchResult, index: number) => {
        const link = `/clients/${tract.clientNumber}/projects/${tract.projectNumber}/maps/${tract.fieldNumber}/tracts/${tract.tractNumber}/horizons/1`;

        const match: { prop: string; value: string }[] = Object.keys(tract.tractAttributes)
            .filter((k) => tract.tractAttributes[k] !== null)
            .map<{ prop: string; value: string }>((k) => {
                return { prop: k, value: tract.tractAttributes[k] };
            });

        return (
            <div className="tract-card" key={index} onClick={() => dispatch(push(link))}>
                <div>
                    <span>Tract #:</span>
                    {`${tract.fieldNumber}.${tract.tractNumber}`}
                </div>
                <div>
                    <span>Leg Desc:</span>
                    {tract.tract.legalDescription}
                </div>
                <div>
                    <span>Gross Acres:</span>
                    {tract.tract.grossAcres}
                </div>
                <div>
                    <span>{match[0].prop}</span>
                    {match[0].value}
                </div>
            </div>
        );
    };

    return (
        <div className="project__tract-search-panel">
            <div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    {/* <RHFInputBox name="searchTerm" label="Search" register={register} placeholder="Enter Parcel# or Owner Name" /> */}
                    <input style={{width: '39%'}} placeholder="Enter parcel # or owner name" name="searchTerm" ref={register()} />
                    <button type="submit">Submit</button>
                </form>

                {searchPerformed && (
                    <div className="tract-card-list">
                        {searchPerformed &&
                            searchResults.length > 0 &&
                            searchResults.map((result: TractSearchResult, i: number) => tractCard(result, i))}
                        {searchResults.length === 0 && <div>No results</div>}
                    </div>
                )}
            </div>
        </div>
    );
};

export default EasternParcelSearch;



// WEBPACK FOOTER //
// ./src/components/project/sections/EasternParcelSearch.tsx